import api from './api';

export interface Project {
  id: string;
  name: string;
  invoiceIds: string[];
  createdAt: string;
}

export interface ProjectInput {
  name: string;
  invoiceIds: string[];
}

export const projectsApi = {
  list: () => api.get<Project[]>('/projects/me').then((response) => response.data),
  create: (data: ProjectInput) => api.post<Project>('/projects', data).then((response) => response.data),
  update: (id: string, data: ProjectInput) => api.patch<Project>(`/projects/${id}`, data).then((response) => response.data),
  remove: (id: string) => api.delete(`/projects/${id}`),
};
